import { render } from "./SettingsPaymentsAdd.vue?vue&type=template&id=673d7ece"
import script from "./SettingsPaymentsAdd.vue?vue&type=script&lang=js"
export * from "./SettingsPaymentsAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__